import React from 'react';
import './Pagination.css'; // Kita akan buat CSS-nya

const Pagination = ({
  currentPage,
  totalPages,
  itemsPerPage,
  totalItems,
  onPageChange,
  onItemsPerPageChange,
}) => {
  const pageNumbers = [];
  // Tampilkan maksimal 5 nomor halaman di sekitar halaman saat ini
  let startPage = Math.max(1, currentPage - 2);
  let endPage = Math.min(totalPages, currentPage + 2);

  if (totalPages <= 5) {
      startPage = 1;
      endPage = totalPages;
  } else {
      if (currentPage <= 3) {
          startPage = 1;
          endPage = 5;
      } else if (currentPage + 2 >= totalPages) {
          startPage = totalPages - 4;
          endPage = totalPages;
      }
  }

  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  return (
    <div className="pagination-container">
      <div className="pagination-info">
        <span>Menampilkan {(currentPage - 1) * itemsPerPage + 1} - {Math.min(currentPage * itemsPerPage, totalItems)} dari {totalItems} data</span>
      </div>
      <div className="pagination-controls">
        <button
          className="pagination-button"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          &laquo; Prev
        </button>
        {startPage > 1 && (
            <>
                <button className="pagination-button" onClick={() => onPageChange(1)}>1</button>
                {startPage > 2 && <span className="pagination-ellipsis">...</span>}
            </>
        )}
        {pageNumbers.map(number => (
          <button
            key={number}
            className={`pagination-button ${currentPage === number ? 'active' : ''}`}
            onClick={() => onPageChange(number)}
          >
            {number}
          </button>
        ))}
         {endPage < totalPages && (
            <>
                {endPage < totalPages - 1 && <span className="pagination-ellipsis">...</span>}
                <button className="pagination-button" onClick={() => onPageChange(totalPages)}>{totalPages}</button>
            </>
         )}
        <button
          className="pagination-button"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Next &raquo;
        </button>
      </div>
      <div className="items-per-page">
        <label htmlFor="itemsPerPage">Data per halaman:</label>
        <select
          id="itemsPerPage"
          value={itemsPerPage}
          onChange={(e) => onItemsPerPageChange(Number(e.target.value))}
        >
          <option value={10}>10</option>
          <option value={25}>25</option>
          <option value={50}>50</option>
        </select>
      </div>
    </div>
  );
};

export default Pagination;